











































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import {
  employeeApis,
  siteAdminRoleApis,
  siteAdminPermApis,
  Employee,
  SitePerm,
  SiteRole,
  PermGroup,
  roleType
} from '../../api';
import * as _ from 'lodash';
import CustomDatePicker from '../../components/CustomDatePicker.vue';

@Component({ components: { CustomDatePicker } })
export default class PermGrant extends Vue {
  @Prop() siteId!: number;
  @Prop() tabValue!: any;
  activeTab = 'role-grant';

  employees: Array<Employee> = [];
  employeeSearch = '';
  employeeSearching = false;

  roles: Array<SiteRole> = [];
  roleLoading = false;

  permLoading = false;
  permGroups: Array<PermGroup> | null = null;
  permData: Array<any> = [];
  currentRole: SiteRole | null = null;
  currentEmployee: Employee | null = null;

  searchEmployee!: (name: string) => void;

  created() {
    this.searchEmployee = _.debounce(this._searchEmployee, 200);
  }

  async _searchEmployee(name: string) {
    this.employeeSearching = true;
    try {
      this.employees = await employeeApis.search({ name });
    } finally {
      this.employeeSearching = false;
    }
  }

  watchParams() {
    return [this.siteId, this.tabValue];
  }

  mounted() {
    this.searchEmployee('');
    this.refreshRoles();
    this.$watch(this.watchParams, () => {
      this.currentEmployee = null;
      this.roles = [];
      this.currentRole = null;
      this.permGroups = null;
      this.permData = [];
      return this.refreshRoles();
    });
  }

  employeeTitle(e: Employee): string {
    let result = e.display_name;
    if (e.position) {
      result += ` - ${e.position}`;
    }
    return result;
  }

  employeeTooltip(e: Employee): string {
    let result = `${e.username} - ${e.display_name}`;
    if (e.position) {
      result += ` - ${e.position}`;
    }
    return result;
  }

  async refreshRoles() {
    if (this.tabValue == 'grant') {
      this.roleLoading = true;
      try {
        this.roles = await siteAdminRoleApis.getRoles(this.siteId, roleType[this.tabValue]);
      } finally {
        this.roleLoading = false;
      }
    }
  }

  async clickEmployee(employee: Employee) {
    this.currentRole = null;
    this.currentEmployee = employee;
    await this.loadPermState(employee.id, undefined);
  }

  async clickRole(role: SiteRole) {
    this.currentEmployee = null;
    this.currentRole = role;
    await this.loadPermState(undefined, role.id);
  }

  async loadPermState(employeeId?: number, roleId?: number) {
    this.permLoading = true;
    this.permData = [];
    try {
      const groups = await siteAdminPermApis.getPermState(this.siteId, { employeeId, roleId });
      this.permGroups = groups;
      this.permData = groups.map(this._buildGroupData);
    } finally {
      this.permLoading = false;
    }
  }

  _buildGroupData(group: PermGroup): any {
    let children: any = [];
    if (group.perms) {
      children = group.perms.map(p => this._buildPermData(group, p));
    }
    return {
      id: `group-${group.id}`,
      group,
      name: group.name,
      children
    };
  }

  _buildPermData(group: PermGroup, perm: SitePerm): any {
    return {
      id: `perm-${perm.id}`,
      name: perm.name,
      parent: group,
      perm: perm
    };
  }

  async refreshPerms() {
    if (this.currentEmployee) {
      await this.loadPermState(this.currentEmployee.id, undefined);
    } else if (this.currentRole) {
      await this.loadPermState(undefined, this.currentRole.id);
    }
  }

  async save() {
    if (this.permGroups) {
      await siteAdminPermApis.grant(this.siteId, this.permGroups, {
        employeeId: this.currentEmployee?.id,
        roleId: this.currentRole?.id
      });
      this.$notify.success('授权保存成功');
    }
  }

  getDisable(scope: any) {
    if (this.activeTab == 'role-grant') {
      return !scope.row.perm.role_checked;
    } else {
      return !scope.row.perm.employee_checked;
    }
  }
}
